<template>
  <nuxt-link :to="link">
    <ContentTag
      :tag-text="tagText"
      :article="article"
      :background-color="backgroundColor"
      :foreground-color="foregroundColor"
      :font-smaller="fontSmaller"
      :font-weight-bold="fontWeightBold"
      :rounded-pill="roundedPill"
    />
  </nuxt-link>
</template>

<script>
import ContentTag from "~/components/articles/components/ContentTag.vue";

export default {
  name: "ContentTagLink",
  components: { ContentTag },
  props: {
    link: { type: String, required: true },
    tagText: { type: String, default: null },
    article: { type: Object, default: () => ({}) },
    fontSmaller: { type: Boolean, default: true },
    fontWeightBold: { type: Boolean, default: true },
    backgroundColor: { type: String, default: "primary" },
    foregroundColor: { type: String, default: "white" },
    roundedPill: { type: Boolean, default: false },
  },
};
</script>
